'use client';

// npm packages
import React from 'react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// swiper slider
import 'swiper/css';
import 'swiper/css/pagination';
import { cn } from '@/utils/cn';
import ImageComponentV2 from '../Image/ImageComponentV2';

const dummyImages = [
  '/images/product.png',
  '/images/product.png',
  '/images/product.png',
];

function CardSlider3({ data, className, sliderType = '' }) {
  const IMAGE_BASE_URL = process.env.NEXT_PUBLIC_ASSET_URL;

  const images =
    sliderType === 'v2' && data
      ? (Array.isArray(data) ? data : [data]).map((item) => item['1_26x1'])
      : dummyImages;

  return (
    <div
      className={cn(
        'max-w-[161px] lg:max-w-[298px] h-full !max-h-[239px]',
        className,
      )}
    >
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={10}
        slidesPerView={1}
        speed={1000}
        pagination={{ clickable: true }}
        className="swiper_slider card-slider card-slider2 h-full w-full !max-w-[160px] lg:!max-w-[350px] "
      >
        {images?.map((item, index) => (
          <SwiperSlide
            key={index}
            className="!flex !justify-center items-center"
          >
            <div className="relative w-full max-w-[350px] h-[128px] lg:h-[236px] overflow-hidden">
              {sliderType === 'v2' && data ? (
                <ImageComponentV2
                  src={`${IMAGE_BASE_URL}/${item}`}
                  className="w-full h-full object-cover"
                  alt={`product-${index + 1}`}
                  loading="lazy"
                />
              ) : (
                <ImageComponentV2
                  src={item}
                  className="w-full h-full object-cover"
                  width={350}
                  height={236}
                  alt={`product-${index + 1}`}
                  loading="lazy"
                />
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default CardSlider3;
